import * as React from 'react'

import { GridItem, Grid } from '@thg-commerce/gravity-system'
import { styled, Text, spacing } from '@thg-commerce/gravity-theme'
import { ArticlePreview, SectionTitle } from '@thg-commerce/gravity-elements'
import { ArticlePreviewProps } from '@thg-commerce/gravity-elements/ArticlePreview/ArticlePreview'

export interface RelatedArticlesProps {
  articles: ArticlePreviewProps[]
  i18nTitle: string
}

const StyledSectionTitle = styled(SectionTitle)`
  ${Text('large1', 'alternate')};
  text-align: center;
  margin-bottom: ${spacing(2)};
`

const GridNoGutter = styled(Grid)`
  margin: 0;
`

const TitleGridItem = styled(GridItem)`
  margin-bottom: ${spacing(2)};
`

const ArticleGridItem = styled(GridItem)`
  margin-bottom: ${spacing(5)};
`

export const RelatedArticles = ({
  articles,
  i18nTitle,
}: RelatedArticlesProps) => {
  const gridItemColSpan = [12, 6, 6, 3]
  const totalColumns = 12
  const gridItemRowOffset = 2
  const relatedArticles = articles.map((article, index) => {
    const colStart = gridItemColSpan.map(
      (colSpan) => (index % (totalColumns / colSpan)) * colSpan + 1,
    )
    const rowStart = gridItemColSpan.map((colSpan) =>
      Math.floor(index / (totalColumns / colSpan) + gridItemRowOffset),
    )

    article.image.lazy = true

    return (
      <ArticleGridItem
        colSpan={gridItemColSpan}
        colStart={colStart}
        rowStart={rowStart}
        key={`related-article-${index}`}
      >
        <ArticlePreview {...article} />
      </ArticleGridItem>
    )
  })

  return (
    <GridNoGutter>
      <TitleGridItem colSpan={12} colStart={1} rowStart={1}>
        <StyledSectionTitle>{i18nTitle}</StyledSectionTitle>
      </TitleGridItem>
      {relatedArticles}
    </GridNoGutter>
  )
}
